import useEOSClient from "../../clients/eos";
import { EOSEndpoint } from "../../clients/eos/index.enum";
import { useAnalyticsReporting } from "../../utils/hooks/useAnalyticsReporting";
import { OAuthResource } from "../o-auth/index.enum";
import type { GetVehicleHealthReportRawResponse } from "./validation/GetVehicleHealthReport/index.types";
import type { GetVehicleSafetyCampaignsRawResponse } from "./validation/GetVehicleSafetyCampaigns/index.types";

const useVehicleHealthService = () => {
	const eosClient = useEOSClient();

	// TODO: Return response validation into this method once the differences between
	// the api-context and internal service layer are reconciled.
	const findSafetyCampaigns = useAnalyticsReporting(
		(vin: string) =>
			eosClient.post<GetVehicleSafetyCampaignsRawResponse>(
				"/v2/vehicle/safety-campaigns",
				{ vin },
				{
					includeReCaptcha: true,
					OAuth: { enabled: true, resource: OAuthResource.safetyCampaign },
					service: EOSEndpoint.vehicleInfo,
				},
			),
		{ name: "findSafetyCampaigns" },
	);

	// TODO: Return response validation into this method once the differences between
	// the api-context and internal service layer are reconciled.
	const findVehicleHealthReport = useAnalyticsReporting(
		(vin: string) =>
			eosClient.get<GetVehicleHealthReportRawResponse>(
				`/v1/vehicle/${vin}/vehicle-health-report`,
				{
					includeAuth: true,
					service: EOSEndpoint.vehicleHealth,
				},
			),
		{ name: "findVehicleHealthReport" },
	);

	return {
		findSafetyCampaigns,
		findVehicleHealthReport,
	};
};

export default useVehicleHealthService;
